var map = {
	"./ARcity.jpg": "bf73",
	"./elamorph.png": "6a65",
	"./lenticular.jpg": "34d1",
	"./modeling.jpg": "c71f",
	"./pBRDF.png": "4dfe",
	"./path.jpg": "c62c",
	"./prism.png": "c0b2",
	"./sakura.jpg": "db7f",
	"./sponza.jpg": "a229",
	"./vtuber.jpg": "46e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "47e3";